import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { DataDisplayModule } from '../data-display/data-display.module';
import { DataTableModuleV2 } from '../datatable/datatable.module';
import { PopoverIconModule } from '../popover-icon/popover-icon.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { SystemPortfolioOverviewTableComponent } from './system-portfolio-overview-table.component';
import { LevelNameTranslationPipe } from '@twaice-fe/frontend/shared/services';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { FeatureToggleModule } from 'ngx-feature-toggle';

const NG_ZORRO_MODULES = [NzTableModule, NzTagModule, NzBadgeModule, NzToolTipModule];

@NgModule({
  declarations: [SystemPortfolioOverviewTableComponent],
  exports: [SystemPortfolioOverviewTableComponent],
  imports: [
    CommonModule,
    FeatureToggleModule,
    DataTableModuleV2,
    DataDisplayModule,
    SvgIconModule,
    MatDividerModule,
    MatCardModule,
    PopoverIconModule,
    ...NG_ZORRO_MODULES,
    LevelNameTranslationPipe,
    NzPopoverModule,
  ],
})
export class SystemOverviewTableModule {}
